module.exports = __webpack_public_path__ + "static/media/29ADMSPC3.3449cc61.jpg";